module.exports = __webpack_public_path__ + "img/05.68cf6d7f.jpg";